import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, ArrowUpRight, MapPin } from "lucide-react";
import { Logo } from "@/components/site/Logo";
import { NAV, EMAILS } from "@/lib/content";

const slug = (s) => s.toLowerCase().replace(/\s+/g, "-");

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname, hash } = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [pathname, hash]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <header data-testid="site-header" className={`fixed inset-x-0 top-0 z-50 bg-white transition-shadow duration-300 ${scrolled || open ? "shadow-[0_6px_24px_rgba(0,24,112,0.12)]" : ""}`}>
      <div className="bg-[#001870] text-white">
        <div className="mx-auto flex h-8 max-w-[1400px] items-center justify-between gap-4 px-5 text-[12px] md:px-10">
          <span className="flex items-center gap-1.5"><MapPin className="h-3.5 w-3.5 text-[#E3BC6E]" />Port of Brownsville, Texas</span>
          <span className="flex items-center gap-5">
            <a href={`mailto:${EMAILS.press}`} data-testid="topbar-press-link" className="hover:underline"><span className="hidden sm:inline">Press: {EMAILS.press}</span><span className="sm:hidden">Press inquiries</span></a>
          </span>
        </div>
      </div>
      <div className="mx-auto flex h-[84px] max-w-[1400px] items-center justify-between px-5 md:px-10">
        <Logo />
        <nav className="hidden items-center gap-5 lg:flex xl:gap-8" aria-label="Primary">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end data-testid={`nav-${slug(n.label)}`} className={({ isActive }) => `link-underline text-[15px] font-medium text-[#001870] hover:text-[#0a2a9e] ${isActive ? "border-b-2 border-[#AD7F27] pb-0.5 font-semibold" : ""}`}>{n.label}</NavLink>
          ))}
        </nav>
        <div className="hidden items-center gap-3 xl:flex">
          <Link to="/contact" data-testid="nav-cta-contact" className="group flex items-center gap-1 bg-[#001870] px-5 py-3 text-sm font-semibold uppercase tracking-wide text-white transition-colors hover:bg-[#0a2a9e]">
            Reach out <ArrowUpRight className="h-4 w-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </Link>
        </div>
        <button data-testid="mobile-menu-toggle" aria-label="Toggle menu" onClick={() => setOpen((o) => !o)} className="flex items-center gap-2 p-2 font-semibold uppercase text-[#001870] lg:hidden">
          {open ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}<span className="text-sm">Menu</span>
        </button>
      </div>
      {open && (
        <nav data-testid="mobile-menu" className="max-h-[calc(100svh-116px)] overflow-y-auto border-t border-slate-200 bg-white px-5 pb-8 pt-2 lg:hidden" aria-label="Mobile">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} data-testid={`mobile-nav-${slug(n.label)}`} className="font-display block border-b border-slate-200 py-4 text-3xl font-bold uppercase text-[#001870]">{n.label}</Link>
          ))}
        </nav>
      )}
    </header>
  );
};
